import { CoreTabs, ViewAllButton } from '@components'
import { useFeatureFlag } from '@hooks'
import TransactionsRequiringApproval from '@views/dashboard/TransactionsSection/TransactionsRequiringApproval/TransactionsRequiringApproval'
import { paths, RecurringPlanStatuses, useGetRecurringPlansQuery, useGetTransactionsQuery } from 'mmfintech-backend-api'
import { tr } from 'mmfintech-commons'
import { useState } from 'react'

import { Recent } from './Recent'
import { Upcoming } from './Upcoming'

export const DashboardTransactions = () => {
  const hasTransactionApprovalFlow = useFeatureFlag('transactionApprovalFlow')
  const [currentTab, setCurrentTab] = useState<string>('recent')

  const tabs = [
    {
      value: 'recent',
      label: tr('FRONTEND.DASHBOARD.TRANSACTIONS.TAB.RECENT', 'Recent')
    },
    {
      value: 'upcoming',
      label: tr('FRONTEND.DASHBOARD.TRANSACTIONS.TAB.UPCOMING', 'Upcoming')
    }
  ]

  const { isFetching: transactionsFetching } = useGetTransactionsQuery({
    page: 0,
    size: 3,
    sort: 'reqTime-desc,id-desc'
  })
  const { isLoading: recurringPlansLoading } = useGetRecurringPlansQuery(
    { recurringPlanStatuses: [RecurringPlanStatuses.ACTIVE], size: 3 },
    {
      skip: currentTab === 'recent'
    }
  )

  return (
    <div className='transaction-section-wrapper'>
      <div className='transaction-section-header'>
        <h3 data-test='transaction-section-title'>
          {tr('FRONTEND.DASHBOARD.LATEST_TRANSACTIONS_TITLE', 'Latest transactions')}
        </h3>
        <CoreTabs tabs={tabs} onChangeTab={setCurrentTab} tabState={currentTab} />
      </div>

      {hasTransactionApprovalFlow && <TransactionsRequiringApproval />}

      {currentTab === 'recent' && <Recent />}
      {currentTab === 'upcoming' && <Upcoming />}

      {!recurringPlansLoading && !transactionsFetching && (
        <div className='transaction-section-footer'>
          <ViewAllButton
            label={tr('FRONTEND.DASHBOARD.TRANSACTIONS.BUTTON.VIEW_ALL', 'View all')}
            redirect={
              currentTab === 'upcoming'
                ? `${paths.banking.transactions.list()}?tab=recurring`
                : paths.banking.transactions.list()
            }
          />
        </div>
      )}
    </div>
  )
}
